export default "__VITE_ASSET__8n3OKTHb__"